import { render, staticRenderFns } from "./FlexManage.vue?vue&type=template&id=0abc264c&scoped=true"
import script from "./FlexManage.vue?vue&type=script&lang=js"
export * from "./FlexManage.vue?vue&type=script&lang=js"
import style0 from "./FlexManage.vue?vue&type=style&index=0&id=0abc264c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abc264c",
  null
  
)

export default component.exports